<template>
  <div class="afterHome">
    <div class="home-img">
      <img src="./../../assets/back2.png" />
    </div>
    <div class="home-search">
      <div class="home-search-box" @click="goBilityListNor()">
        <div class="home-search-titl">
          <img src="./../../assets/ico-sousuo@2x.png" />
          <span>搜索</span>
        </div>
        <!-- <input type="text" v-model="keywords" /> -->
      </div>
    </div>
    <div class="home-menu">
      <div
        class="menu-box"
        v-for="(type,typeIndex) in typeList"
        :key="typeIndex"
        @touchend="goBilityList(type.Id)"
      >
        <div class="menu-box-img" :class="'menuBox-back'+ typeIndex">
          <img :src="menuList[typeIndex].img" />
        </div>
        <div class="menu-box-text">{{type.Name}}</div>
      </div>
    </div>
    <div class="home-scroll">
      <div class="scroll-span" @click="goPolicyList">
        <img src="./../../assets/ico-wenjian@2x.png" />
      </div>
      <div class="scroll-live" ref="scrollLive">
        <div class="scroll-live-box">
          <p
            v-for="(item, index) in policyList"
            :key="index"
            :class="{scrollTop: scrollTop}"
            @click="goPolicyInfo(item)"
          >{{item.Title}}</p>
        </div>
      </div>
    </div>
    <div class="home-depart">
      <div class="home-depart-title">
        <span>部门服务</span>
        <span @click="goDepartListPage">更多</span>
      </div>
      <div class="home-depart-list">
        <div
          class="home-depart-list-unit"
          v-for="(dep, depIndex) in departList"
          :key="depIndex"
          @click="goBilityByDep(dep)"
        >
          <img src="./../../assets/icon-@2x.png" />
          <p>{{dep.Name}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import remSet from "./../../utils/rem.js";
export default {
  data() {
    return {
      scrollTop: false,
      policyList: [],
      menuList: [
        {
          img: require("./../../assets/ico-xuke@2x.png")
        },
        {
          img: require("./../../assets/ico-chufa@2x.png")
        },
        {
          img: require("./../../assets/ico-qiangzhi@2x.png")
        },
        {
          img: require("./../../assets/ico-zhengshou@2x.png")
        },
        {
          img: require("./../../assets/ico-geifu@2x.png")
        },
        {
          img: require("./../../assets/ico-jiancha@2x.png")
        },
        {
          img: require("./../../assets/ico-queren@2x.png")
        },
        {
          img: require("./../../assets/ico-qita@2x.png")
        }
      ],
      typeList: [],
      departList: [],
      keywords: ""
    };
  },
  beforeCreate() {
    remSet();
  },
  mounted() {
    this.getTypeList();
    this.initGetPolicyList();
    this.getDepartList();
  },
  methods: {
    scrollPolicy() {
      setInterval(() => {
        this.scrollTop = true;
        setTimeout(() => {
          let one = this.policyList[0];
          this.policyList = this.policyList.splice(1);
          this.policyList.push(one);
          this.scrollTop = false;
        }, 3000);
      }, 5000);
    },
    goBilityListNor() {
      this.goBilityList(this.departList[0].Id);
    },
    goBilityList(id) {
      this.$store.commit("home/setMenuActive", id);
      this.$router.push({
        path: "/bility"
      });
    },
    goBilityByDep(dep) {
      this.$store.commit("home/setMenuActive", this.departList[0].Id);
      this.$router.push({
        path: "/bility",
        query: {
          depId: dep.Id,
          deptName: dep.Name
        }
      });
    },
    initGetPolicyList() {
      this.$axios({
        url: "api/getArticleList",
        type: "get",
        params: {
          areacode: "00"
        }
      })
        .then(res => {
          this.policyList = res.data.articleList;
          if (this.policyList.length > 0) {
            this.scrollPolicy();
          }
        })
        .catch(err => {
          console.info(err);
        });
    },
    goPolicyInfo(item) {
      this.$router.push({ path: "/policyInfos", query: { Id: item.Id } });
    },
    goPolicyList() {
      if (this.policyList.length > 0) {
        this.$router.push({
          path: "/policyList"
        });
      }
    },
    getTypeList() {
      this.$axios({
        url: "api/getTypeList",
        method: "get",
        params: {
          areacode: "00"
        }
      })
        .then(res => {
          this.typeList = res.data.typeList;
        })
        .catch(err => {
          console.info(err);
        });
    },
    getDepartList() {
      this.$axios({
        url: "api/getDeptList",
        method: "get",
        params: {
          areacode: "00"
        }
      })
        .then(res => {
          this.departList = res.data.deptList.splice(0, 9); //截取前9名用于展示
        })
        .catch(err => {
          console.info(err);
        });
    },
    goDepartListPage() {
      this.$store.commit("home/setMenuActive", this.departList[0].Id);
      this.$router.push({
        path: "/departSearch"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.afterHome {
  width: 100%;
  height: 100%;
  position: relative;
  .home-img {
    width: 100%;
    height: 9.07rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .home-search {
    width: 100%;
    height: 2.67rem;
    margin-top: -1.09rem;
    display: flex;
    justify-content: center;
    .home-search-box {
      width: 18.93rem;
      height: 2.67rem;
      position: relative;
      background-color: #ffffff;
      border-radius: 0.16rem;
      box-shadow: 0.11rem 0.11rem 0.32rem rgba(179, 179, 179, 0.17);
      input {
        width: 100%;
        height: 2.67rem;
        line-height: 2.67rem;
        border: 0px;
        border-radius: 0.16rem;
        box-shadow: 0.11rem 0.11rem 0.32rem rgba(179, 179, 179, 0.17);
        background-color: transparent;
        outline: none;
        padding: 0 1rem;
      }
      .home-search-titl {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 10;
        img {
          width: 0.79rem;
          height: 0.79rem;
          margin-right: 0.29rem;
        }
        span {
          display: inline-block;
          height: 0.8rem;
          line-height: 0.8rem;
          color: #6b6b6b;
          font-size: 0.8rem;
        }
      }
    }
  }
  .home-scroll {
    width: 100%;
    height: 2.4rem;
    display: flex;
    // padding: 0 1rem;
    box-shadow: 0.11rem 0.11rem 0.32rem rgba(179, 179, 179, 0.17);
    .scroll-span {
      width: 3rem;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 1.52rem;
        height: 1.68rem;
      }
    }
    .scroll-live {
      width: calc(100% - 3rem);
      height: 100%;
      overflow-y: hidden;
      position: relative;
      &::after {
        content: "";
        width: 0.05rem;
        height: 1.76rem;
        background-color: rgba(234, 234, 234, 1);
        border-radius: 0rem;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        z-index: 50;
      }
      .scroll-live-box {
        width: 100%;
        height: auto;
        p {
          padding: 0 0.72rem 0 0.56rem;
          width: 100%;
          height: 2.4rem;
          display: inline-block;
          vertical-align: middle;
          text-align: left;
          font-size: 0.7rem;
          position: relative;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 2.4rem;
          cursor: pointer;
          // &::before {
          //   content: "·";
          //   width: 0.5rem;
          //   height: 2.4rem;
          //   line-height: 2.4rem;
          //   text-align: center;
          //   position: absolute;
          //   top: 0;
          //   bottom: 0;
          //   left: 0;
          //   margin: auto;
          //   z-index: 1;
          //   font-size: 1rem;
          //   font-weight: bolder;
          // }
        }
      }
    }
  }
  .home-menu {
    width: 100%;
    height: 8.53rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    box-shadow: 0.11rem 0.11rem 0.32rem rgba(179, 179, 179, 0.17);
    // padding: 1rem 0;
    .menu-box {
      width: 25%;
      height: auto;
      // padding: 0.5rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      .menu-box-img {
        width: 3rem;
        height: 3rem;
        border-radius: 50%;
        padding: 0.5rem;
        // &.menuBox-back0 {
        //   background-color: #ff0000;
        // }
        // &.menuBox-back1 {
        //   background-color: #ff99ff;
        // }
        // &.menuBox-back2 {
        //   background-color: #999900;
        // }
        // &.menuBox-back3 {
        //   background-color: #c648f5;
        // }
        // &.menuBox-back4 {
        //   background-color: #f6ac1b;
        // }
        // &.menuBox-back5 {
        //   background-color: #1fd04c;
        // }
        // &.menuBox-back6 {
        //   background-color: #3b96e9;
        // }
        // &.menuBox-back7 {
        //   background-color: #336699;
        // }
        img {
          width: 100%;
          height: 100%;
        }
      }
      .menu-box-text {
        width: 100%;
        line-height: 1rem;
        font-size: 0.75rem;
      }
    }
  }

  .home-depart {
    width: 100%;
    height: 10.22rem;
    padding: 1rem 0.5rem;
    .home-depart-title {
      width: 100%;
      height: 1rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        color: #333333;
        font-family: "PingFang-SC-Heavy";
        &:first-of-type {
          font-size: 0.96rem;
        }
        &:last-of-type {
          font-size: 0.8rem;
        }
      }
    }
    .home-depart-list {
      width: 100%;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .home-depart-list-unit {
        width: 33%;
        height: 2rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        img {
          width: 0.5rem;
          height: 0.5rem;
          margin-right: 0.25rem;
        }
        p {
          height: 2rem;
          color: #666666;
          font-size: 0.8rem;
          text-align: left;
          line-height: 2rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
        }
      }
    }
  }
}

@keyframes scrollTop {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    transform: translate3d(0, -100%, 0);
  }
}

.scrollTop {
  animation-name: scrollTop;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  animation-duration: 3s;
  animation-iteration-count: 1;
}
</style>